/* Vueraith / Atelier header progressive enhancement.
 * Keep navigation, search, links and cart functional without JavaScript.
 * No fetch calls, tracking, camera or private data.
 */
(function () {
  'use strict';
  function ready() {
    var header = document.querySelector('[data-vr-atelier-header]');
    if (!header || header.dataset.vrAtelierReady === 'true') return;
    header.dataset.vrAtelierReady = 'true';
    document.documentElement.classList.add('vr-atelier-enhanced');

    var menu = header.querySelector('[data-vr-atelier-menu]');
    var search = header.querySelector('[data-vr-atelier-search]');
    var groups = Array.prototype.slice.call(header.querySelectorAll('[data-vr-atelier-group]'));
    var mobileGroups = Array.prototype.slice.call(header.querySelectorAll('[data-vr-atelier-mobile-group]'));
    var menuTrigger = menu && menu.querySelector('summary');
    var searchTrigger = search && search.querySelector('summary');
    var home = header.classList.contains('vr-atelier--home');
    var scrolled = false;

    function updateScroll() {
      if (!home) return;
      var next = window.scrollY > 24;
      if (scrolled === next) return;
      scrolled = next;
      header.classList.toggle('is-scrolled', scrolled);
    }
    function removeScrollLock() {
      document.documentElement.classList.remove('vr-atelier-menu-open');
    }
    function closeElement(details, restoreFocus) {
      if (!details || !details.open) return;
      details.open = false;
      if (restoreFocus) {
        var summary = details.querySelector('summary');
        if (summary) summary.focus();
      }
    }
    function closeAll(except) {
      groups.concat(mobileGroups).forEach(function (group) {
        if (group !== except) group.open = false;
      });
      if (search !== except) closeElement(search, false);
      if (menu !== except) closeElement(menu, false);
    }
    function focusables() {
      if (!menu || !menu.open) return [];
      return [menuTrigger].concat(Array.prototype.slice.call(menu.querySelectorAll(
        '.vr-atelier__mobile-panel a[href],.vr-atelier__mobile-panel summary,' +
        '.vr-atelier__mobile-panel input:not([disabled]),' +
        '.vr-atelier__mobile-panel button:not([disabled])'
      ))).filter(function (node) {
        return node.getClientRects().length > 0;
      });
    }
    if (menu) {
      menu.addEventListener('toggle', function () {
        if (menu.open) {
          closeAll(menu);
          document.documentElement.classList.add('vr-atelier-menu-open');
          if (menuTrigger) menuTrigger.setAttribute('aria-label', 'Close Vueraith navigation');
          var first = menu.querySelector('.vr-atelier__mobile-navigation a[href],.vr-atelier__mobile-navigation summary');
          if (first) first.focus({preventScroll:true});
        } else {
          removeScrollLock();
          if (menuTrigger) menuTrigger.setAttribute('aria-label', 'Open Vueraith navigation');
        }
      });
    }
    if (search) {
      search.addEventListener('toggle', function () {
        if (!search.open) return;
        closeAll(search);
        var input = search.querySelector('input[type="search"]');
        if (input) input.focus({preventScroll:true});
      });
    }
    groups.forEach(function (group) {
      group.addEventListener('toggle', function () {
        if (!group.open) return;
        closeAll(group);
      });
    });
    mobileGroups.forEach(function (group) {
      group.addEventListener('toggle', function () {
        if (!group.open) return;
        mobileGroups.forEach(function (other) {
          if (other !== group) other.open = false;
        });
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        var target = document.activeElement;
        var nested = target && target.closest('[data-vr-atelier-mobile-group][open]');
        if (nested) {
          closeElement(nested, true);
          event.preventDefault();
          return;
        }
        if (menu && menu.open) {
          closeElement(menu, true);
          event.preventDefault();
          return;
        }
        if (search && search.open) {
          closeElement(search, true);
          event.preventDefault();
          return;
        }
        var openGroup = groups.find(function (group) {return group.open;});
        if (openGroup) {
          closeElement(openGroup, true);
          event.preventDefault();
          return;
        }
      }
      if (event.key === 'Tab' && menu && menu.open) {
        var elements = focusables();
        if (!elements.length) return;
        var current = elements.indexOf(document.activeElement);
        var destination;
        if (event.shiftKey && (current <= 0)) destination = elements[elements.length - 1];
        if (!event.shiftKey && (current < 0 || current === elements.length - 1)) destination = elements[0];
        if (destination) {
          event.preventDefault();
          destination.focus();
        }
      }
    });
    document.addEventListener('click', function (event) {
      if (header.contains(event.target)) {
        if (menu && menu.open && event.target.closest('.vr-atelier__mobile-panel a[href]')) {
          closeElement(menu, false);
        }
        return;
      }
      closeAll(null);
    });
    var viewport = window.matchMedia('(min-width:1051px)');
    var savedPanel = header.querySelector('.vr-atelier__saved');
    var savedMobileSlot = header.querySelector('[data-vr-atelier-saved-mobile]');
    var desktopUtilities = header.querySelector('.vr-atelier__utilities');
    var cartLink = header.querySelector('.vr-atelier__cart');
    function placeSavedPanel() {
      if (!savedPanel || !savedMobileSlot || !desktopUtilities || !cartLink) return;
      if (viewport.matches) desktopUtilities.insertBefore(savedPanel, cartLink);
      else savedMobileSlot.append(savedPanel);
    }
    placeSavedPanel();
    if (typeof viewport.addEventListener === 'function') viewport.addEventListener('change', function (event) {
      placeSavedPanel();
      if (event.matches) closeElement(menu, false);
    });
    if (home) {
      updateScroll();
      window.addEventListener('scroll', updateScroll, {passive:true});
    }
    // A normal href stays available when the Shopify cart dialog is absent.
    // The existing Vueraith drawer code owns the '[data-vr-open-cart]' click.
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
}());
